import React, { useState } from 'react';

export const BonusCalculatorSection: React.FC = () => {
  const [bonusAmount, setBonusAmount] = useState('');
  const [wager, setWager] = useState('35');
  const [betAmount, setBetAmount] = useState('');
  const [result, setResult] = useState<{ totalBet: number; betsCount: number } | null>(null);

  const calculateWager = () => {
    const bonus = parseFloat(bonusAmount);
    const wagerMultiplier = parseFloat(wager);
    const bet = parseFloat(betAmount);

    if (bonus && wagerMultiplier && bet) {
      const totalBet = bonus * wagerMultiplier;
      const betsCount = Math.ceil(totalBet / bet);
      setResult({ totalBet, betsCount });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-700 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Калькулятор отыгрыша бонусов
          </h2>
          <p className="text-xl opacity-90">Рассчитайте вейджер вашего бонуса</p>
        </div>

        <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div>
              <label className="block text-sm font-medium mb-2">Сумма бонуса (₽)</label>
              <input
                type="number"
                value={bonusAmount}
                onChange={(e) => setBonusAmount(e.target.value)}
                placeholder="10000"
                className="w-full px-4 py-3 rounded-xl bg-white/20 border border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white/50 transition-colors"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Коэффициент вейджера (x)</label>
              <select
                value={wager}
                onChange={(e) => setWager(e.target.value)}
                className="w-full px-4 py-3 rounded-xl bg-white/20 border border-white/30 text-white focus:outline-none focus:border-white/50 transition-colors cursor-pointer"
              >
                <option value="25" className="text-gray-900">x25</option>
                <option value="30" className="text-gray-900">x30</option>
                <option value="35" className="text-gray-900">x35</option>
                <option value="40" className="text-gray-900">x40</option>
                <option value="45" className="text-gray-900">x45</option>
                <option value="50" className="text-gray-900">x50</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Ваша ставка (₽)</label>
              <input
                type="number"
                value={betAmount}
                onChange={(e) => setBetAmount(e.target.value)}
                placeholder="100"
                className="w-full px-4 py-3 rounded-xl bg-white/20 border border-white/30 text-white placeholder-white/60 focus:outline-none focus:border-white/50 transition-colors"
              />
            </div>
          </div>

          <button
            onClick={calculateWager}
            className="w-full py-4 bg-white text-blue-600 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer mb-6"
          >
            Рассчитать
          </button>

          {result && (
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 text-center">
              <p className="text-3xl font-bold mb-2">
                Необходимо поставить: ₽{result.totalBet.toLocaleString('ru-RU')}
              </p>
              <p className="text-lg opacity-90">
                Количество ставок: {result.betsCount.toLocaleString('ru-RU')}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};